import { FC, HTMLAttributes } from "react";
import clsx from "clsx";

// --------------------------------------------------------------------------------------

export type ICourseDeliverablesSectionProps = HTMLAttributes<HTMLElement> & {
  heading?: string;
  cards?: {
    heading?: string;
  }[];
};

const CourseDeliverablesSection: FC<ICourseDeliverablesSectionProps> = (
  props,
) => {
  const { heading, cards, className, ...other } = props;

  return (
    <section
      className={clsx(
        "pb-5 pt-10 lg:pb-8 lg:pt-16 xl:pb-[50px] xl:pt-[100px]",
        className,
      )}
      {...other}
    >
      <div className="container">
        {heading && (
          <h2 className="mb-5 text-h5 font-medium text-black-900 dark:text-white md:mb-7 lg:mb-10 lg:text-h3 xl:mb-14 xl:text-h2">
            {heading}
          </h2>
        )}

        {cards && cards.length > 0 && (
          <div className="grid grid-cols-12 gap-5 md:gap-7 xl:gap-8">
            {cards.map((item, idx) => (
              <div
                key={idx}
                className="col-span-full bg-gradient-to-r from-primary-900 to-white p-px md:col-span-6 lg:col-span-4"
              >
                <div className="size-full bg-black-900 md:min-h-[96px] lg:min-h-[140px] xl:min-h-[206px]">
                  <div className="h-full bg-gradient-to-r from-primary-900 to-primary-900/10 p-2 text-h5 md:px-7 md:py-5 lg:px-10 lg:py-7 xl:px-12 xl:py-11">
                    <div className="flex h-full items-end">
                      <h5 className="text-lg font-normal text-white dark:text-white lg:text-h6 xl:text-h5 xl:leading-9">
                        {item.heading}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default CourseDeliverablesSection;
